import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey, password, username } from '../internal.js'

const credentialTypes = [username, password, apiKey] as const

export type nmtfCredType = (typeof credentialTypes)[number]
export const nmtfDocumentTypes = [
  'inspection-certificate',
  'invoice',
  'lumper-certificate',
  'partner-bill-of-lading',
  'proof-of-delivery',
  'signed-bol',
  'weight-cert',
] as const satisfies readonly DocumentType[]

export const nmtf: CarrierDef<nmtfCredType> = {
  name: 'N&M Transfer Company',
  scac: 'nmtf',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  credentialTypes,
  legacyCredMap: [
    ['api-key', 'apiKey'], // engine
  ],
  engineLayers: ['rating', 'pickup', 'documents', 'tracking', 'profinder'],
  documentTypes: nmtfDocumentTypes,
}
